import { ButtonIconPosition } from "../../button";
import { A11Y_MIN_SIZE } from "../../utils";
export var ICON_ONLY_SIZE = Math.max(24, A11Y_MIN_SIZE);
export var defaultProps = {
  iconPosition: ButtonIconPosition.Trailing,
  isExpanded: false,
  hasOutline: false,
  shouldSetAriaExpanded: true
};